module.exports = __webpack_public_path__ + "img/team1.586916c5.png";